<template>
    <keep-alive>
         <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size md_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>{{$t('TITLE.POPUP.SELECT.AREA.OF.ANSWER')}}</i>
                        </dt>
                        <dd>
                            <!-- Grid -->
                            <div class="grid_wrap">
                                <!-- detail_Authorization-->
                                <table class="create_table"><!-- 200604수정 -->
                                    <colgroup>
                                        <col width="18%" />
                                        <col width="*" />
                                        <col width="18%" />
                                        <col width="*" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>{{params.dynLabel1}}</th>
                                            <td>{{params.dynValue1}}</td>
                                            <th>{{params.dynLabel2}}</th>
                                            <td>{{params.dynValue2}}</td>
                                        </tr>
                                        <tr>
                                            <th>{{$t('FIELD.GLOBAL.PERIOD')}}</th>
                                            <td :colspan="{3: params.dynLabel3}">{{params.strDate}} ~ {{params.endDate}}</td>
                                            <th>{{params.dynLabel3}}</th>
                                            <td>{{params.dynValue3}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- <div class="grid_total">
                                    {{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em>
                                    <a href="javascript:" class="btn_white" @click="excelDownload()">{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                                </div> -->
                                <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
                                <div class="btn_modal_wrap topLine" style="padding:10px 1px 10px 1px; margin:5px 0px 1px 0px;" >
                                    <div class="btn_right">
                                        <a href="javascript:" class="btn_white"  @click="excelDownload()" v-if="params.btnShow">{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                                    </div>
                                </div>
                                <div class="grid_wrap">
                                    <toast-grid
                                        :gridId="gridId"
                                        :data="gridData"
                                        :columns="columns"
                                        :options="options"
                                        :pageOptions="pageOptions"
                                        :key="gridKey"
                                        :click="contentClick"
                                        :isTotalCount="false"
                                    />
<!--                                     <div class="paginate">
                                        <sdl-pagination
                                            :current-page="currentPage"
                                            :total-rows="resultCount"
                                            :per-page="perPage"
                                            @change="onSearch"
                                            align="center"
                                        />
                                    </div>
 -->                                </div>
                            </div>
                        </dd>
                    </dl>

                    <div class="btn_modal_wrap topLine" style="padding:10px 30px 10px 1px; margin:5px 0px 1px 0px;">
                        <div class="btn_right">
                            <a href="JavaScript:" class="btn_white" title @click="$emit('close')">{{$t('BUTTON.GLOBAL.CLOSE')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import ToastGrid from '~c/ToastGrid';
import { mapGetters } from 'vuex';
import api from '@/service';
import ExcelDownloadPopup  from '~vb/common/ExcelDownloadPopup';
import questionDetailPopup from '~vb/faq/popup/questionDetailPopup';

const fetchContentsList = params => axios.post(
    `${SDLUtil.API_URL}/basis/main/listDashboardContents.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'selectAnswerPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            systemId: 'getSystemId'
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
        getSystemId() {
            return this.systemId || '';
        }
    },
    props: {
        'pParams': { type: Object, default: {} },
        rtnUserFunc: { type: Function }
    },
    data() {
        return {
            gridId: 'searchPopupGrid',
            params: this.pParams,
            rhqCd: '',
            corpNo: '',
            btnShow : false,
            gridKey: 0,
            dynLabel1: '',
            dynLabel2: '',
            resultCount: 0,
            perPage: 8,
            currentPage: 1,
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.NO'),
                    name: 'RNUM',
                    align: 'center',
                    width: 50,
                    resizable: true,
                    sortable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.QUESTION.ID'),
                    name: 'QUESTION_ID',
                    align: 'center',
                    width: 150,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'),
                    name: 'TITLE',
//                    align: 'center',
//                    width: 250,
                    sortable: true
                }
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: false,

                minBodyHeight: 200,
                bodyHeight: 320,
                rowHeight: 32
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 8,
            }
        };
    },
    methods: {
        async onSearch(page) {
            let url = this.params.url;
            let param = this.params;
//            let pgMode = param.pageMode;
//            if (pgMode == '1')      url = `${SDLUtil.API_URL}/basis/admin/statisticsManager/reportByAnswerersPop.skp`;
//            else if (pgMode == '2') url = `${SDLUtil.API_URL}/basis/admin/statisticsManager/satisIndexByGBMPops.skp`;
//            else                    url = `${SDLUtil.API_URL}/basis/admin/statisticsManager/reportByAnswerersPop.skp`;

            param.perPage = this.perPage;
            param.page = page;
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(url,
                    qs.stringify(param), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.resultCount = resp.data.totalCount;
                    console.log('pop.resp.data ==> ', resp.data);
                    this.gridData = resp.data.rows;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    console.log(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async getContentList(contType) {
            return await fetchContentsList(contType);
        },
        contentClick(e, rowData, grid) {
            let questKey = rowData[e.rowKey]['QUESTION_ID'];
            let option = { width: '500px', height: 'auto' };

            let params = {
                searchKey: questKey,
                rtnFunc: () => {
                    this.getContentList({ contType: 'S' }).then(res => {
                        let data = res.data;
                        if (data.contentsList.rowCount > 0) {
                            this.supportList = data.contentsList.rowData;
                        }
                    });
                },
            };

            SDLUtil.show(questionDetailPopup, params, option);
            // console.log('contentClick',e.rowKey,curRowKey,$('.radio-icon')[curRowKey].checked,rowData[e.rowKey]['CDMODEL'],rowData[e.rowKey]['NMMODEL']);
        },
        excelDownload() {
            let url = `${SDLUtil.API_URL}/basis/admin/statisticsManager/bySubsidiaryPopExcel.skp`;
            SDLUtil.confirm({
                //msg: SDLUtil.getMsgProp('MESSAGE.EXCEL.ALERT.MAXROWS'),
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 1000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            url,
                            qs.stringify(this.params),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
    },
    mounted() {
        // console.log('Pop.this.params ======> ', this.params);
        // console.log('Pop.this.dynLabel1 ===> ', this.params.dynLabel1);
        // console.log('Pop.this.dynLabel2 ===> ', this.params.dynLabel2);
        this.onSearch(1);
    }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/StstLinkPopup.vue